import '../stylesheets/talent_profile_listings.scss';

// FAQ Section Toggle Functionality
document.addEventListener('DOMContentLoaded', () => {
  const faqQuestions = document.querySelectorAll('.faq-question');

  faqQuestions.forEach((question) => {
    question.addEventListener('click', () => {
      const faqItem = question.closest('.faq-item');
      const isCurrentlyExpanded = faqItem.classList.contains('expanded');
      const toggleIcon = faqItem.querySelector('.faq-toggle-icon');

      if (!isCurrentlyExpanded) {
        faqItem.classList.add('expanded');
        question.setAttribute('aria-expanded', 'true');
        toggleIcon.textContent = '−';
      } else {
        faqItem.classList.remove('expanded');
        question.setAttribute('aria-expanded', 'false');
        toggleIcon.textContent = '+';
      }
    });
  });

  // Back to top functionality
  const backToTopBtn = document.querySelector('.back-to-top-btn');
  if (backToTopBtn) {
    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }

  // Form submission for candidate exploration

  const submitExploreForm = (event) => {
    event.preventDefault();

    const locationSelect = document.getElementById('location');
    const positionSelect = document.getElementById('position');

    const locationValue = locationSelect.value;
    const positionValue = positionSelect.value;

    // Build the URL
    let url = `/employers/hire/nurses/${locationValue}`;

    // Add position as query parameter if selected
    if (positionValue && positionValue !== 'all specialties') {
      url += `/${encodeURIComponent(positionValue)}`;
    }

    // Navigate to the new URL
    window.location.href = url;
  };
  const exploreForm = document.querySelector('.explore-form form');
  if (exploreForm) {
    exploreForm.addEventListener('submit', submitExploreForm);
  }
  const mobileExploreForm = document.querySelector('.mobile-explore-form form');
  if (mobileExploreForm) {
    mobileExploreForm.addEventListener('submit', submitExploreForm);
  }
});
